<template>
    <modal-component 
        :title="$helpers.trans('auth.registerModalTitle')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            name="Login" 
            action="/register" 
            :spam-filter="false"
            @success="registrationComplete()">

            <div class="form-group">
                <input id="register_firstname" type="text" required class="form-control" :class="{ 'used': user.firstname }" name="firstname" v-model="user.firstname">
                <label for="register_firstname" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.firstname') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="register_lastname" type="text" required class="form-control" :class="{ 'used': user.lastname }" name="lastname" v-model="user.lastname">
                <label for="register_lastname" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.lastname') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="register_email" type="email" required class="form-control" :class="{ 'used': user.email }" name="email" v-model="user.email">
                <label for="register_email" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.email') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <input id="login_password" type="password" required class="form-control" :class="{ 'used': user.password }" name="password" v-model="user.password">
                        <label for="login_password" class="form-label">
                            <span class="form-label__content">{{ $helpers.trans('auth.password') }}</span>
                        </label>
                        <div class="invalid-feedback"></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input id="login_password_confirmation" type="password" required class="form-control" :class="{ 'used': user.password_confirmation }" name="password_confirmation" v-model="user.password_confirmation">
                        <label for="login_password_confirmation" class="form-label">
                            <span class="form-label__content">{{ $helpers.trans('auth.passwordConfirmation') }}</span>
                        </label>
                        <div class="invalid-feedback"></div>
                    </div>
                </div>
            </div>

        </form-component>

        <div slot="footer" v-if="complete">
            <span class="btn btn-default" @click="$emit('update:open', false)">Close</span>
        </div>
    </modal-component>
</template>
<script>
import ModalComponent from '@app/components/Modal.vue'
import FormComponent from '@app/components/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: null,
                password: null,
                password_confirmation: null,
                firstname: null,
                lastname: null,
            },

            complete: false,
        }
    },

    methods: {
        registrationComplete() {
            this.complete = true;
            this.user = {
                email: null,
                password: null,
                password_confirmation: null,
                firstname: null,
                lastname: null,
            };
        }
    }
}
</script>
